export default __webpack_public_path__ + "static/media/packers_black.c1af2a38.png";